import { thousands } from '@/utils/number';

/**
 *
 * @description 自定义指令： v-thousands 转 123456789.1234567 -> 123,456,789.1234567
 * @description 自定义指令： v-thousands.p1 转 123456789.1234567 -> 123,456,789.1
 * @description 自定义指令： v-thousands.p2 转 123456789.1234567 -> 123,456,789.12
 * @description 自定义指令： v-thousands.p3 转 123456789.1234567 -> 123,456,789.123
 * @description 自定义指令： v-thousands.p4 转 123456789.1234567 -> 123,456,789.1235
 * @description 自定义指令： v-thousands 转 '' -> ''
 * @description 自定义指令： v-thousands.dash 转 '' -> '--'
 * @description 需要在外层包裹父节点
 * @param {app} app vue实例
 */

const _thousands = function(el, binding) {
    const m = binding.modifiers;
    let precision;

    if (m.p1) {
        precision = 1;
    } else if (m.p2) {
        precision = 2;
    } else if (m.p3) {
        // eslint-disable-next-line no-magic-numbers
        precision = 3;
    } else if (m.p4) {
        // eslint-disable-next-line no-magic-numbers
        precision = 4;
    }

    const txt = thousands(binding.value, '', precision);

    el.textContent = txt || (m.dash ? '--' : '');
};

/**
 *
 * @description 自定义指令： v-money 转 123456789.234 -> 123,456,789.23
 * @description 需要在外层包裹父节点
 * @param {app} app vue实例
 */

const money = function(el, binding) {
    el.textContent = thousands(binding.value, '--', 2);
};

/**
 *
 * @description 自定义指令： v-weight 转 123456789.1234 -> 123,456,789.12
 * @description 自定义指令： v-weight.ton 转 123456789.1234 -> 123,456,789.123
 * @description 需要在外层包裹父节点
 * @param {app} app vue实例
 */

const weight = function(el, binding) {
    // eslint-disable-next-line no-magic-numbers
    el.textContent = thousands(binding.value, '--', binding.modifiers.ton ? 3 : 2);
};

/**
 *
 * @description 自定义指令： v-percent 转 123456789.123456 -> 123,456,789.123456%
 * @description 需要在外层包裹父节点
 * @param {app} app vue实例
 */

const percent = function(el, binding) {
    const txt = thousands(binding.value, '', binding.modifiers.p2 && 2);
    el.textContent = txt ? `${txt}%` : '--';
};

/**
 *
 * @description 自定义指令： v-percent-x100 转 123456789.123456 -> 123,456,7.89123456%
 * @description 需要在外层包裹父节点
 * @param {app} app vue实例
 */

const percentX100 = function(el, binding) {
    // el.textContent = thousands(binding.value * 100, '--', binding.modifiers.p2 && 2);
    const txt = thousands(binding.value * 100, '', binding.modifiers.p2 && 2);
    el.textContent = txt ? `${txt}%` : '--';
};

function install(app) {
    app.directive('thousands', { updated: _thousands, mounted: _thousands });

    app.directive('money', { updated: money, mounted: money });

    app.directive('weight', { updated: weight, mounted: weight });

    app.directive('percent', { updated: percent, mounted: percent });

    app.directive('percent-x100', { updated: percentX100, mounted: percentX100 });
}

export default {
    install: install
};
